import * as types from './types';
import {
  AdminSystemSettingListModel,
  AdminSystemSettingEditModel,
} from 'src/model/index';
import {
  extend,
  findIndex
} from 'lodash';

export default{
// 获取用户列表
  actionGetAdminSystemSettingList({commit, state}, query){
    if (state.settingList.state === 'loading') {
      return Promise.reject('loading');
    }
    commit(types.ADMIN_SETTING_LIST_CHANGE, {
      'state': 'loading'
    });
    return AdminSystemSettingListModel.getInstance().execute(query).then((response) => {
      commit(types.ADMIN_SETTING_LIST_CHANGE, {
        'state': 'loadend',
        'list': response.list
      });
      return response;
    }).catch((err) => {
      commit(types.ADMIN_SETTING_LIST_CHANGE, {
        'state': 'loaderr'
      })
      return Promise.reject(err);
    });
  },

  // 处理后台表单配置
  actionAdminSystemSettingItemChange({commit}, result){
    commit(types.ADMIN_SETTING_ITEM_CHANGE, result);
  },

  // 创建或修改权限
  actionCreateAdminManageSettingItem({commit, state}, query){
    return AdminSystemSettingEditModel.getInstance().execute(query)
  },
}






// WEBPACK FOOTER //
// ./src/store/Admin/modules/Settings/actions.js